export const REDUCER_KEY = "miniPlayer";
export const UPDATE_MINI_PLAYER = "UPDATE_MINI_PLAYER";
export const SET_IS_WEBPLAYER = "SET_IS_WEBPLAYER";
export const SET_SLUG_WEBPLAYER = "SET_SLUG_WEBPLAYER";
export const UPDATE_MODAL = "UPDATE_MODAL";
export const SET_EXPANDED_PLAYER_OPEN_STATE = "SET_EXPANDED_PLAYER_OPEN_STATE";
